<template>
  <div @click="clickRight" class="right-btn" :class="{disabled:disabled || loading}">
    <Loading v-if="loading" color="white" type="spinner" size="18px"/>
    <img v-else src="./img/right.png" alt="">
  </div>
</template>

<script>
  import {Loading} from 'vant';

  export default {
    name: 'RightBtn',
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data:function(){
      return {
        canClick: true,//这个是用来解决ios快速点击两次页面下移的问题，和业务代码没有半点关系，全部删除也没有影响
      }
    },

    methods: {
      clickRight(e) {
        if(!this.canClick){
          this.canClick = true;
          e.preventDefault();
          return false;
        }
        if (this.disabled || this.loading) {
          e.preventDefault();
          return false;
        }
        this.canClick = false;
        setTimeout(()=>{this.canClick = true;},300);
        this.$emit('clickRight')
      }
    },
    components: {Loading}
  }
</script>

<style lang="scss" scoped>
  .right-btn {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: #FF5555;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 12px;
    }

    &.disabled {
      background-color: #E2E3E5;
    }
  }
</style>
